export default "__VITE_ASSET__DCDEEuSq__"